import moment from 'moment';
import { useRef } from 'react';

import {
  commonPDFStyleOverrides,
  generateSolaforcePDFFromReact,
} from '~/utils/generatePDF';
import { getExportFileName } from '~/utils/helper';

type PropsType = {
  title: string;
  subtitle?: string;
  startDate?: Date;
  endDate?: Date;
};

export const usePersonnelReportPDFExport = (props: PropsType) => {
  const { title, subtitle, startDate, endDate } = props;

  const pdfRef = useRef<HTMLElement>(null);

  const onReportPDFExport = () => {
    const content = pdfRef.current;

    const contentHeight = !!content ? content?.clientHeight ?? 0 : 0;

    const resolveSubtitle = () => {
      if (!!subtitle) {
        return subtitle;
      }
      if (
        !!startDate &&
        !!endDate &&
        moment(startDate).diff(moment(endDate), 'day') !== 0
      ) {
        return `${moment(startDate).format('L')} - ${moment(endDate).format(
          'L',
        )}`;
      }
      if (!!startDate) {
        return moment(startDate).format('L');
      }
      return undefined;
    };

    if (!!content) {
      generateSolaforcePDFFromReact({
        fileName: getExportFileName({
          title,
          startDate,
        }),
        documentDetails: {
          title,
          subtitle: resolveSubtitle(),
        },
        contentSize: {
          height: contentHeight + 20,
        },
        content,
        config: {
          styleOverrideRules: [commonPDFStyleOverrides.muiPaper],
        },
      });
    }
  };

  return {
    pdfRef,
    onReportPDFExport,
  };
};
